export default {"src":"/_next/static/media/WY.f68f78a1.svg","height":18,"width":18};